"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateListenerToken = void 0;
const crypto_1 = require("crypto");
function generateListenerToken() {
    return new Promise((resolve, reject) => {
        crypto_1.randomBytes(8, (err, buf) => {
            if (err) {
                return reject(err);
            }
            resolve(buf.toString('hex'));
        });
    });
}
exports.generateListenerToken = generateListenerToken;
//# sourceMappingURL=listenerToken.js.map